var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('div',_vm._g(_vm._b({staticClass:"svg-icon",domProps:{"innerHTML":_vm._s(_vm.icon)}},'div',_vm.$attrs,false),_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }